// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.remind.list/calendar.remind.list.scss
// module id = 4923
// module chunks = 50